var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"ico-wrapper"},[_c('CheckCircle',{staticClass:"ico"})],1),_c('p',{domProps:{"innerHTML":_vm._s(_vm.componentProps.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }